import { C } from "../constants";
import { Sec, STitle } from "../components/Shared";

const posts = [
  { date: "March 2026", title: "Why AI-Powered Message Filtering is the Future of Online Safety", excerpt: "Traditional keyword blocking misses context. Here's how AI understands the difference between playground banter and genuine harm.", tag: "Technology" },
  { date: "February 2026", title: "5 Conversations to Have About Online Messaging", excerpt: "Before handing over a phone, here are the conversations that set the right foundations.", tag: "Guidance" },
  { date: "January 2026", title: "How SafeZapp's Smart Rewrite Teaches Empathy", excerpt: "Blocking harmful messages is step one. Teaching a better way to express yourself is where real change happens.", tag: "Product" },
  { date: "December 2025", title: "Understanding the UK Age Appropriate Design Code", excerpt: "What the Children's Code means for apps that serve vulnerable users, and how SafeZapp exceeds its requirements.", tag: "Compliance" },
];

export default function Blog() {
  return (
    <Sec>
      <STitle tag="Blog" title="Insights & News" sub="Thoughts on online safety, technology, and better communication" />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 22 }}>
        {posts.map((p, i) => (
          <div key={i} style={{
            background: C.white, borderRadius: 14, overflow: "hidden",
            border: `1px solid ${C.border}`, cursor: "pointer", transition: "transform 0.2s"
          }}
            onMouseEnter={e => e.currentTarget.style.transform = "translateY(-3px)"}
            onMouseLeave={e => e.currentTarget.style.transform = ""}
          >
            <div style={{
              height: 150,
              background: [C.blueLight, C.accentLight, C.yellowLight, "#E8F4FD"][i % 4],
              display: "flex", alignItems: "center", justifyContent: "center"
            }}>
              <span style={{ fontSize: 44, opacity: 0.5 }}>{["📱", "💬", "⚡", "📋"][i % 4]}</span>
            </div>
            <div style={{ padding: 22 }}>
              <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 10 }}>
                <span style={{
                  fontFamily: "'Nunito', sans-serif", fontSize: 11.5, fontWeight: 700,
                  color: C.blueDark, background: C.blueLight, padding: "3px 10px", borderRadius: 6
                }}>{p.tag}</span>
                <span style={{ fontFamily: "'Nunito', sans-serif", fontSize: 11.5, color: C.textLight }}>{p.date}</span>
              </div>
              <h3 style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 700, fontSize: 16, color: C.text, margin: "0 0 6px", lineHeight: 1.4 }}>{p.title}</h3>
              <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: 13.5, color: C.textMid, lineHeight: 1.6, margin: 0 }}>{p.excerpt}</p>
            </div>
          </div>
        ))}
      </div>
    </Sec>
  );
}
